import { useState, useEffect } from 'react'
import { Card, Descriptions, Tag, Timeline, Tooltip, Tabs } from 'antd'
import { Loading } from 'Components'
import axios from 'axios'

export default ChangelogList = ({ changelistUrl, keyId, hasCurrentVersion }) ->
  { TabPane } = Tabs

  [data, setData] = useState([])

  [isLoading, setIsLoading] = useState(false)

  useEffect( ->
    ( ->
      getVersionData(changelistUrl, keyId, hasCurrentVersion)
    )()
    undefined
  , [])

  getVersionData = (changelistUrl, keyId, hasCurrentVersion) ->
    setIsLoading(true)

    if keyId is 'sdkChangelist'
      rawData = await axios.request({
        method: "get"
        url: changelistUrl
        crossDomain: true
      })
      organisedData = organiseVersionData(rawData.data)
    else if keyId is 'serverChangelist'
      rawData = await Weaver.getInstance().getCoreManager().serverChangelog()
      organisedData = organiseVersionData(rawData)
    else if keyId is 'dbChangelist'
      rawData = await Weaver.getInstance().getCoreManager().connectorChangelog()
      organisedData = organiseVersionData(rawData)

    if hasCurrentVersion then (
      currentVersion = await Weaver.getInstance().version()
      organisedData = filterVersions(organisedData, currentVersion)
    )

    setData(organisedData)
    setIsLoading(false)

  organiseVersionData = (rawData) ->
    hasDate = RegExp('[0-9]')
    versions = rawData.split('## ')
    versionObjs = versions.map((version) ->
      if hasDate.test(version.split(/- /).splice(1, 1))
        date = version.split(/- /).splice(1, 1)
        content = version.split(/- /).slice(2)
      else
        date = '-'
        content = version.split(/- /).slice(1)
      {
        versionNo: parseInt(version.split(/- /).shift().replace(/\D+/g, ''))
        date: date
        heading: version.split(/- /).shift().replace(/^\s+|\s+$/g, '')
        content: content
      }
    ).slice(1)

  filterVersions = (versionList, currentVersion) ->
    current = parseInt(currentVersion.replace(/\D+/g, ''))
    versionList.filter ((ver) -> ver.versionNo <= current)

  <>
    {if isLoading then (
      <div style={{height: '70vh', textAlign: 'center'}}>
        <Loading style={{height: '100%'}}/>
      </div>
    ) else (
      <Timeline key={keyId} style={{ marginLeft: 76, paddingTop: 25 }} mode='left'>
        {
          data.map (item) ->
            <Timeline.Item key={item.heading} style={{ margin: '0 0 0 30px'}}>
            <span style={{
              left: -135,
              top: 1,
              position: 'relative',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              display: 'inline-block',
              whiteSpace: 'nowrap',
              width: 105
            }}>{ item.date }</span>
            <div className="triangle" />
              <Card
                key="changelogItem-#{item.heading}"
                title="v#{item.heading}"
                bordered={false}
                style={{
                  position: 'relative',
                  top: -39,
                  width: '100%',
                  backgroundColor: 'var(--background)',
                  borderRadius: 5,
                  boxShadow: '0 3px 10px 0 rgba(0, 0, 0, 0.06)'
                }}
                headStyle={{ border: 'none' }}
                bodyStyle={{ padding: '0 24px 18px' }}
              >
                <Descriptions layout="horizontal" bordered={true} column={1}>
                  {
                    item.content.map (contItem, index) ->
                      <Descriptions.Item
                        label={<Tag color='green'>New</Tag>}
                        span={1}
                        key="changeItem-#{index}"
                      >
                        <li
                          key="changeContent-#{index}"
                          style={{ listStyle: 'initial', listStyleType: 'none' }}
                        >
                          { contItem }
                        </li>
                      </Descriptions.Item>
                  }
                </Descriptions>
              </Card>
            </Timeline.Item>
        }
      </Timeline>
    )}
  </>
